<template>
  <div class="content-wrap">
    <transition name="header-fade" appear>
      <div class="header-section">
        <h1 class="page-title">内容中心</h1>
        <div class="subtitle">CONTENT CENTER</div>
      </div>
    </transition>

    <div class="content-list">
      <transition-group
        name="card-slide"
        tag="div"
        appear
      >
        <div
          class="content-card"
          v-for="(item, index) in contentList"
          :key="item.id"
          @click="goToDetail(item.id)"
          :style="{ transitionDelay: `${index * 80}ms` }"
        >
          <div class="card-cover">
            <span class="card-number">{{ String(index + 1).padStart(2, '0') }}</span>
            <div class="cover-img">
              <img :src="item.cover" :alt="item.title" />
            </div>
          </div>
          <div class="card-content">
            <h2 class="card-title">{{ item.title }}</h2>
            <!-- <div class="card-desc">{{ item.description }}</div> -->
            <div class="view-btn">
              查看详情
              <div class="arrow-icon">
                <svg viewBox="0 0 24 24" fill="none">
                  <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </transition-group>
    </div>

    <Footer />
  </div>
</template>

<script>
import { Footer } from '@/components'

function requireImg(str) {
  return require('pbimages/content/' + str)
}

export default {
  name: 'Content',
  components: {
    Footer,
  },
  data() {
    return {
      contentList: [
        {
          id: 1,
          title: '律师自述 | 500起刑民交叉案件后，他总结出这套「零遗漏」日程管理法',
          description: '在隋丛军律师的职业生涯中，曾有过一次有惊无险的教训。回溯到五年前，彼时他正被堆积如山的案头工作所困，一次关键的疏忽，让两个案件的开庭日程险些完全重叠...',
          cover: requireImg('resized-cover1.png'),
        },
        {
          id: 2,
          title: '上海律杏信息科技有限公司加入上海法律科技协会',
          description: '上海法律科技协会成立于2025年7月，以"深化科技在法律领域的应用，推动法律与科技良性互动、融合发展，提升法律服务智能化水平，助力上海法治建设"为服务宗旨，致力于开展法律科技政策宣传、调查研究、标准制定、信息交流...',
          cover: requireImg('resized-cover2.png'),
        },
        {
          id: 3,
          title: '干货分享 | 律师如何躺收案源？设置好这个，让白嫖党自动退退退！',
          description: '作为律师，就免不了被客户、被周围的亲朋好友以所谓"做人情"的方式白嫖，这已成为一种普遍且令人疲惫的行业现象。在法律行业，律师被客户"白嫖"——即客户通过各种方式获取免费法律咨询而不愿支付相应费用——已成为普遍存在的职业困境...',
          cover: requireImg('resized-cover3.png'),
        },
        {
          id: 4,
          title: '一位律师的六年深度使用笔记：我的"全天候律师助理"',
          description: '我于2018年踏入律师行业，2019年进入实习律师阶段，2020年正式执业至今。实习期间，因带教师父承办大量批量性系列案件，需反复进行机械性的文书录入与案件台账管理工作。为提升效率、保障工作质量，我先后试用了多款律师案件管理系统，最终选定 "案件云" 并沿用至今...',
          cover: requireImg('resized-cover4.png'),
        },
        {
          id: 5,
          title: '做独立律师最怕的事情：忘记开庭',
          description: '记错开庭日期真是独立律师最大的噩梦了，以前在团队里的时候，同事之间还能互相照顾提醒下，独立之后但凡有点错误，哪怕是无心之失，也可能会有大麻烦。所以做好案件时间管理，对独立律师来说非常重要。',
          cover: requireImg('resized-cover5.png'),
        },
        {
          id: 6,
          title: '告别繁琐协作：一套案件管理系统，让律所每个人各司其职',
          description: '在法律行业，效率与风险控制是永恒的主题。律师深陷于多案并行的压力，行政疲于应付流程审批，管理者难以看清全局数据——这些痛点，往往源于团队内部角色不清、工具分散、信息不通。',
          cover: requireImg('resized-cover6.png'),
        },
        {
          id: 7,
          title: '当用户问："你们产品，是不是有律师参与？',
          description: '经常有用户这样问我们，每当听到这些留言，我们都倍感荣幸。用户每一次真诚的肯定都是对案件云产品最高的褒奖。确实，市面上的管理工具千千万，但很多律师用起来总觉得隔靴搔痒：要么是功能太泛，无法适配诉讼的复杂流程；要么是设计太硬，不懂法律人对风险的深层焦虑。',
          cover: requireImg('resized-cover7.png'),
        },
        {
          id: 8,
          title: '2026律所案件管理系统推荐，谁才是中国律所的数字化"最优解"？',
          description: '在法律行业从"经验驱动"向"数据驱动"转型的今天，一家律所的核心竞争力已不仅仅取决于大律师的个人能力，更取决于律所整体的组织效率与协作水平。对于管理者而言，如何从繁杂的事务中解放人力？如何规避执业风险？如何让财务数据清晰透明？',
          cover: requireImg('resized-cover8.png'),
        },
        {
          id: 9,
          title: '一份优秀的案件报告应该怎么写？',
          description: '在律师的日常工作中，办案和汇报往往同样重要。很多律师有过这样的困扰：明明自己在案件上投入了大量精力，做了很多隐形的工作，但当事人因为看不到过程，总觉得律师"没干活"。一份高质量的案件报告，不仅是向客户展示工作成果的"成绩单"📝，更是管理客户预期、建立信任感的关键工具。',
          cover: requireImg('resized-cover9.png'),
        },
      ],
    }
  },
  methods: {
    goToDetail(id) {
      this.$router.push({ name: 'ContentDetail', query: { id } })
    },
  },
}
</script>

<style lang="stylus" scoped>
.content-wrap {
  min-height: 100vh;
  background: #f7f6fb;
}

.header-section {
  padding: 60px 36px 40px;
  text-align: center;
}

.page-title {
  font-size: 48px;
  font-weight: 800;
  color: #303443;
  line-height: 1;
  margin-bottom: 12px;
}

.subtitle {
  font-size: 24px;
  font-weight: 500;
  color: #7E818F;
  letter-spacing: 4px;
  animation: subtitle-pulse 2s ease-in-out infinite;
}

@keyframes subtitle-pulse {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 1;
  }
}

.content-list {
  padding: 0 36px 60px;
}

.content-card {
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 32px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 20px;
    padding: 2px;
    background: linear-gradient(135deg, rgba(255, 144, 0, 0) 0%, rgba(255, 144, 0, 0) 100%);
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    opacity: 0;
    transition: opacity 0.4s ease;
  }

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 48px rgba(255, 144, 0, 0.12), 0 8px 24px rgba(0, 0, 0, 0.08);

    &::before {
      background: linear-gradient(135deg, rgba(255, 144, 0, 0.6) 0%, rgba(255, 120, 0, 0.4) 100%);
      opacity: 1;
    }

    .cover-img {
      &::after {
        opacity: 0.4;
      }

      img {
        transform: scale(1.08);
      }
    }

    .card-number {
      transform: scale(1.1) rotate(-3deg);
      box-shadow: 0 12px 32px rgba(255, 144, 0, 0.5), 0 4px 12px rgba(0, 0, 0, 0.2);
    }

    .card-title {
      color: #FF9000;
    }

    .view-btn {
      background: linear-gradient(135deg, #FF9000 0%, #FF7800 100%);
      color: #ffffff;
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(255, 144, 0, 0.3);

      .arrow-icon {
        transform: translateX(4px);
      }
    }
  }

  &:active {
    transform: translateY(-4px);
  }
}

.card-cover {
  position: relative;
  height: 220px;
  overflow: hidden;
  background: linear-gradient(180deg, #f5f5f5 0%, #e8e8e8 100%);
}

.card-number {
  position: absolute;
  top: 16px;
  left: 16px;
  font-size: 40px;
  font-weight: 800;
  color: #ffffff;
  z-index: 2;
  min-width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(255, 144, 0, 0.95) 0%, rgba(255, 120, 0, 0.9) 100%);
  box-shadow: 0 8px 24px rgba(255, 144, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.15);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  animation: number-float 3s ease-in-out infinite;
  border: 2px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(8px);
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes number-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
}

.cover-img {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
    opacity: 0.2;
    transition: opacity 0.4s ease;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
}

.card-content {
  padding: 28px 24px 24px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.card-title {
  font-size: 30px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 44px;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  transition: color 0.3s ease;
  letter-spacing: 0.5px;
}

.card-desc {
  font-size: 26px;
  font-weight: 400;
  color: #666666;
  line-height: 40px;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.view-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  font-weight: 600;
  color: #FF9000;
  padding: 14px 28px;
  border-radius: 12px;
  background: rgba(255, 144, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: 2px solid transparent;
  letter-spacing: 0.5px;
  align-self: flex-end;

  .arrow-icon {
    margin-left: 8px;
    width: 20px;
    height: 20px;
    transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
    display: flex;
    align-items: center;

    svg {
      width: 100%;
      height: 100%;
    }
  }
}

// 页面头部渐入动画
.header-fade-enter-active {
  animation: headerFadeIn 0.8s ease-out;
}

@keyframes headerFadeIn {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 卡片滑入动画
.card-slide-enter-active {
  animation: cardSlideIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
